import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f683114"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inspector-dashboard" }
const _hoisted_2 = { class: "inspector-services" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header py-2" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Actual Services")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "body no-services"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, "Don't have any service yet.", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "body py-2"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-primary mt-3",
  "data-bs-toggle": "modal",
  "data-bs-target": "#addServiceModal"
}, "ADD SERVICE", -1))
const _hoisted_12 = {
  class: "modal fade modal-l",
  id: "addServiceModal",
  tabindex: "-1",
  "aria-labelledby": "Add Service Modal",
  "aria-hidden": "true"
}
const _hoisted_13 = { class: "modal-dialog" }
const _hoisted_14 = { class: "modal-content" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1))
const _hoisted_16 = { class: "modal-body" }
const _hoisted_17 = { class: "input-container" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inspectorServiceSelect" }, "Servicios:", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select an Option", -1))
const _hoisted_20 = ["value"]
const _hoisted_21 = {
  key: 0,
  class: "success-message"
}
const _hoisted_22 = {
  key: 0,
  class: "error-message"
}
const _hoisted_23 = { class: "modal-footer tw-flex tw-items-center tw-justify-between" }
const _hoisted_24 = { class: "tw-flex tw-justify-end tw-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.inspectorServices === undefined || _ctx.inspectorServices === null || _ctx.inspectorServices.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inspectorServices, (service, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "service"
              }, [
                _createTextVNode(_toDisplayString(service) + " ", 1),
                _createElementVNode("button", {
                  class: "btn btn-danger btn-sm ms-2",
                  onClick: ($event: any) => (_ctx.deleteService(index, service))
                }, _hoisted_10, 8, _hoisted_8)
              ]))
            }), 128))
          ]))
    ]),
    _hoisted_11,
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _withDirectives(_createElementVNode("select", {
                name: "inspectorServiceSelect",
                id: "inspectorServiceSelect",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.serviceSelected) = $event))
              }, [
                _hoisted_19,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.servicesOptions, (service, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: index,
                    value: service
                  }, _toDisplayString(service), 9, _hoisted_20))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.serviceSelected]
              ])
            ]),
            _createVNode(_Transition, { name: "fade" }, {
              default: _withCtx(() => [
                (_ctx.success)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.message), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_Transition, { name: "fade" }, {
              default: _withCtx(() => [
                (_ctx.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.message), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.addService()), ["prevent"]))
              }, "ADD SERVICE")
            ])
          ])
        ])
      ])
    ])
  ]))
}